import React from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { ClassActiveNav } from '../NavMenu';
import { useLocation } from 'react-router-dom';
import { SubMenu, MenuItem } from 'react-pro-sidebar';
import { darkModeBackgroud } from '../../../utils/constants';
import { useDarkModeStore } from '../../../store/useDarkModeStore';
import { useLanguageStore } from '../../../store/useLanguageStore';
import { NavMenuItem, SubMenuSettings } from '../../../domain/helpers/NavMenuItem';

interface ItemWithSubMenuSettingsProps {
    isCollapsed: boolean;
    selectedNav: string;
    navMenuItem: NavMenuItem;
    expandedSubMenuId: number | null;
    expandedSubMenuSettingId: number | null;
    handleRedirect: (path: string) => void;
    handleSubMenuClick: (id: number) => void;
    handleSubMenuSettingsClick: (id: number) => void;
    activeSubMenu: (i: NavMenuItem) => ClassActiveNav;
    activeSubSubMenu: (i: SubMenuSettings) => ClassActiveNav;
}

export const ItemWithSubMenuSettings: React.FC<ItemWithSubMenuSettingsProps> = ({
    isCollapsed,
    selectedNav,
    navMenuItem,
    expandedSubMenuId,
    expandedSubMenuSettingId,
    handleRedirect,
    activeSubMenu,
    handleSubMenuClick,
    activeSubSubMenu,
    handleSubMenuSettingsClick,
}) => {

    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore();
    const location = useLocation().pathname;

    const isTextCentered = isCollapsed ? 'text-center' : '';
    const isItemCollapsed = isCollapsed ? `d-none` : '';

    const subMenuLabel = <div className={isTextCentered}>
        {navMenuItem.icon}
        <span className={isItemCollapsed}>{language[navMenuItem.name] ?? navMenuItem.name}</span>
    </div>;

    const handleClickMenuItem = (route: string) => handleRedirect(route);

    const subSubMenuLabel = (name: string) => {
        return <div>
            <span>{language[name] ?? name}</span>
        </div>
    }

    const urlIncludesSetting = location.includes('/settings');
    const hoverSettings = darkMode ? 'active-nav-item-dark' : 'active-nav-item';

    return <SubMenu
        key={navMenuItem.id}
        label={subMenuLabel}
        style={darkMode ? { color: 'white' } : {}}
        open={expandedSubMenuId === navMenuItem.id}
        title={language[navMenuItem.name] || navMenuItem.name}
        className={`nav-bar-item ${urlIncludesSetting && hoverSettings}`}
        onOpenChange={() => handleSubMenuClick(navMenuItem.id)}
    >
        {
            navMenuItem.subMenuSettings?.map(subMenuSetting =>
                <SubMenu
                    key={subMenuSetting.id}
                    className={`nav-bar-item ${activeSubSubMenu(subMenuSetting)}`}
                    style={darkMode ? { color: 'white', background: darkModeBackgroud } : {}}
                    label={subSubMenuLabel(subMenuSetting.name)}
                    open={expandedSubMenuSettingId === subMenuSetting.id}
                    onOpenChange={() => handleSubMenuSettingsClick(subMenuSetting.id)}
                    title={language[subMenuSetting.name] || subMenuSetting.name}
                >
                    {
                        subMenuSetting.subMenuItemSettings.map(subMenuItemSetting =>
                            <MenuItem
                                key={subMenuItemSetting.id}
                                className={`nav-bar-item ${activeSubMenu(navMenuItem)}`}
                                style={darkMode ? { color: 'white', background: darkModeBackgroud } : {}}
                                onClick={() => handleClickMenuItem(subMenuItemSetting.route)}
                                title={language[subMenuItemSetting.name] || subMenuItemSetting.name}
                            >
                                <CircleIcon sx={{ width: '10px', height: '10px', marginLeft: '2px' }} className={selectedNav === subMenuItemSetting.route ? 'active-nav-sub-item' : ''} />
                                <span className="ms-3" style={selectedNav === subMenuItemSetting.route ? { color: darkMode ? 'white' : '#58595a' } : {}} >
                                    {language[subMenuItemSetting.name]}
                                </span>
                            </MenuItem>
                        )
                    }
                </SubMenu>

            )
        }
    </SubMenu>
}
export default ItemWithSubMenuSettings